// API base URL resolution order:
//   1. REACT_APP_API_BASE_URL env var (if set at build time) wins — useful for one-off overrides.
//   2. Otherwise, infer from the hostname the app is served from at runtime so one build works for all environments:
//        www.bluehippo.io  → prod  backend
//        app.bluehippo.io  → prod  backend
//        dev.bluehippo.io  → dev   backend
//        localhost / 127.* → '/skynet_sfmc_mc' (relative, handled by src/setupProxy.js)
//   3. Final fallback: '/skynet_sfmc_mc' (relative, safe for unknown hosts behind a proxy).
function resolveBaseUrl() {
    if (process.env.REACT_APP_API_BASE_URL) return process.env.REACT_APP_API_BASE_URL;
    if (typeof window === 'undefined') return '/skynet_sfmc_mc';
    const host = window.location.hostname;
    if (host === 'www.bluehippo.io' || host === 'app.bluehippo.io') {
        return 'https://www.bluehippo.io/skynet_sfmc_mc_prod/';
    }
    if (host === 'dev.bluehippo.io') {
        return 'https://dev.bluehippo.io/skynet_sfmc_mc';
    }
    return '/skynet_sfmc_mc';
}

export const API_BASE_URL = resolveBaseUrl();
